class ContactForm {
    constructor() {
        console.log('ContactForm bubble constructor loaded');
    }

    onCustomFormSubmit = (): boolean => {
        console.log('onCustomFormSubmit bubble method fired');
        return true;
    };
}

export default ContactForm;
